// extracted by mini-css-extract-plugin
export default {"Next":"Categories_Next__8FaiO","Prev":"Categories_Prev__zACAr","NextEvents":"Categories_NextEvents__G9J9x","PrevEvents":"Categories_PrevEvents__TIAGn"};